import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); }
    catch (ex) { setErr(errMsg(ex)); }
    finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="Puade" className="h-20 w-auto mx-auto mb-3" data-testid="login-logo" />
          <h1 className="text-xl sm:text-2xl font-serif-display font-bold text-[#1A2627]">Puade OS</h1>
          <p className="text-sm text-[#536263] mt-2">Sistem Operasi untuk Dekorasi &amp; Event Styling</p>
          <div className="mt-3 h-px w-16 bg-[#B87333] mx-auto"></div>
        </div>

        <form onSubmit={submit} className="card-editorial p-6 sm:p-8 space-y-5">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#B87333]">Email</label>
            <input
              data-testid="login-email-input"
              type="email" value={email} onChange={e => setEmail(e.target.value)} required
              className="w-full mt-2 bg-white border border-[#E2DDD3] rounded-lg px-3.5 py-2.5 h-11 focus:outline-none focus:ring-2 focus:ring-[#0F5257]/20 focus:border-[#0F5257]"
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#B87333]">Password</label>
            <input
              data-testid="login-password-input"
              type="password" value={password} onChange={e => setPassword(e.target.value)} required
              className="w-full mt-2 bg-white border border-[#E2DDD3] rounded-lg px-3.5 py-2.5 h-11 focus:outline-none focus:ring-2 focus:ring-[#0F5257]/20 focus:border-[#0F5257]"
            />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{err}</div>}
          <button data-testid="login-submit-button" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Masuk"}
          </button>
        </form>

      </div>
    </div>
  );
}
